<template>
    <q-dialog
        v-model="isOpen"
        content-class="upload-image"
        @input="toggleDialog"
    >
        <q-card>
            <q-card-section>
                <div class="dialog-title text-capitalize q-mb-sm">
                    {{ $t('actions.select_image') }}
                </div>
                <q-input
                    v-model="search"
                    class="q-mb-sm"
                    type="text"
                    debounce="300"
                    :placeholder="$t('actions.search')"
                    outlined
                    dense
                    @input="fetchPictures"
                >
                    <template v-slot:append>
                        <q-icon name="search" />
                    </template>
                </q-input>
                <q-spinner-pie
                    v-if="isFetchingPictures"
                    color="primary"
                    size="40px"
                />
                <template v-else>
                    <div class="uploaded-images">
                        <div
                            v-for="(picture, index) in pictures"
                            :key="index"
                            class="image-wrap"
                        >
                            <img :src="getImage(picture)" alt="" />
                            <div class="overlay" @click="selectImage(picture)">
                                <q-icon
                                    name="check"
                                    color="white"
                                    size="32px"
                                ></q-icon>
                            </div>
                            <q-tooltip
                                ><span class="text-subtitle1">{{
                                    picture.name
                                }}</span>
                            </q-tooltip>
                        </div>
                    </div>
                    <p
                        v-if="pictures.length == 0"
                        class="q-mx-sm text-capitalize text-grey"
                    >
                        {{ $t('general.none_found') }}
                    </p>
                    <div class="row">
                        <div class="col"></div>
                        <div class="col-auto">
                            <q-pagination
                                v-if="pagination.max != 0"
                                v-model="pagination.page"
                                color="black"
                                outline
                                :max="pagination.max"
                                :direction-links="true"
                                @input="fetchPictures"
                            ></q-pagination>
                        </div>
                    </div>
                </template>
                <p class="q-mt-md text-capitalize">{{ $t('general.or') }}</p>
                <div class="form-warp">
                    <q-form>
                        <q-file
                            v-model="image"
                            class="q-mb-lg"
                            bg-color="white"
                            :label="$t('actions.upload_image')"
                            dense
                            outlined
                            clearable
                            max-file-size="2048000"
                            @rejected="onRejected"
                        >
                            <template v-slot:prepend>
                                <q-icon name="insert_photo" />
                            </template>
                        </q-file>
                    </q-form>
                </div>
            </q-card-section>
            <q-card-actions align="right">
                <q-btn
                    flat
                    :label="$t('actions.cancel')"
                    @click="toggleDialog"
                />
                <q-btn
                    flat
                    :label="$t('actions.accept')"
                    color="secondary"
                    :disable="!image"
                    @click="saveImage"
                />
            </q-card-actions>
            <q-inner-loading :showing="isSavingImage">
                <q-spinner-gears size="50px" color="primary" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<script>
import base64 from '@/local-shared/mixins/base64'
import picturesService from '@/services/pictures'
import notify from '@/local-shared/mixins/notify'
import _ from 'lodash'
import env from '@/.env.js'

const loadingKeys = {
    savingImage: 'saving-image',
    fetchingPictures: 'fetching-pictures',
}

export default {
    name: 'UploadImage',

    mixins: [base64, notify],

    props: {
        show: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'image',
        },
        createdBy: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            isOpen: false,

            image: null,
            data: null,

            pictures: [],
            pagination: {
                page: 1,
                rowsPerPage: 10,
                rowsNumber: 0,
                max: 1,
            },
            search: '',
        }
    },

    computed: {
        isSavingImage() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.savingImage
            ).length
        },

        isFetchingPictures() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingPictures
            ).length
        },
    },

    watch: {
        show(value) {
            this.isOpen = value
        },

        image(value) {
            this.getBase64File(value)
        },
    },

    created() {
        this.fetchPictures()
    },

    methods: {
        toggleDialog() {
            this.$emit('toggle-dialog', !this.isOpen)
        },

        async fetchPictures() {
            this.loadingAdd(loadingKeys.fetchingPictures)

            let parameters = {
                filter: {
                    name: this.search,
                    createdBy: this.createdBy,
                    noData: true,
                },
                pagination: {
                    perPage: this.pagination.rowsPerPage,
                    currentPage: this.pagination.page,
                },
                orderBy: [
                    {
                        column: 'created_at',
                        direction: 'desc',
                    },
                ],
            }

            let response = await picturesService.retrieve(parameters)

            if (response.status === 200) {
                // this.pictures = []
                // response.data.results.forEach((e) => {
                //     this.pictures.push({
                //         picture_id: e.id,
                //         name: e.name,
                //         data: this.getBase64Server(e),
                //     })
                // })
                this.pictures = response.data.results
                let total = response.data.pagination.total
                let pages = total / this.pagination.rowsPerPage
                this.pagination.max = Math.ceil(pages)
            } else {
                this.notifyError(response)
            }

            this.loadingRemove(loadingKeys.fetchingPictures)
        },

        selectImage(picture) {
            console.log(picture)
            this.$emit('select-image', picture)
            this.toggleDialog()
        },

        getImage(picture) {
            return env.endpoint_backend + '/pictures/' + picture?.id
        },

        async saveImage() {
            this.loadingAdd(loadingKeys.savingImage)

            let parameters = {
                data: [
                    {
                        name: this.image.name,
                        data: _.split(this.data, 'base64,')[1],
                    },
                ],
            }

            var response = await picturesService.create(parameters)
            if (response.status === 200 && response.data.data[0].id) {
                this.$emit(
                    'select-image',
                    URL.createObjectURL(this.image),
                    response.data.data[0].id
                )
                this.toggleDialog()
            } else {
                this.notifyError(response)
            }

            this.loadingRemove(loadingKeys.savingImage)
        },

        onRejected() {
            this.$q.notify({
                type: 'negative',
                message: this.$t('notifications.file_size_cannot_exceed', {
                    size: '2MB',
                }),
            })
        },
    },
}
</script>
